export default __webpack_public_path__ + "static/media/qrcode.444e71a1.svg";